import { render, staticRenderFns } from "./AssignmentBasicInfo.vue?vue&type=template&id=c07d6d8a&scoped=true"
import script from "./AssignmentBasicInfo.vue?vue&type=script&lang=js"
export * from "./AssignmentBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./AssignmentBasicInfo.vue?vue&type=style&index=0&id=c07d6d8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07d6d8a",
  null
  
)

export default component.exports